module.exports = __webpack_public_path__ + "static/media/arrow-left.6da641a1.svg";